import { ColourOption } from "Components/CommonComponents/customselectdata";
import Typography from "Components/CommonComponents/Typography";
import { useState } from "react";
import { default as ReactSelect } from "react-select";
import {
  components,
  IndicatorSeparatorProps,
  MenuListProps,
  MultiValueGenericProps,
  ValueContainerProps,
  MultiValueRemoveProps,
} from "react-select";
// import { Button } from "reactstrap";
import "./customSelect.css";
export const Option = (props: any) => {
  return (
    <div className="menuMultiOption">
      <components.Option {...props}>
        <>
          <div className="customMultiSelectMainDiv">
            <input
              className="form-check-input"
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
            />{" "}
            <span>{props.label}</span>
          </div>
        </>
      </components.Option>
    </div>
  );
};

export const MultiValue = (props: any) => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);
export const MultiValueContainer = (
  props: MultiValueGenericProps<ColourOption>
) => {
  return <components.MultiValueContainer {...props} />;
};

export const ValueContainer = ({ ...props }: ValueContainerProps) => {
  const singlevalue: any = props.getValue();
  const onevalue: any = singlevalue[0];
  // const length = singlevalue.length;
  return (
    <components.ValueContainer {...props}>
      <div className="valueContainerMainDiv">
        <Typography variant="body1" color="black">
          {onevalue?.label ? onevalue?.label : ""}
          {/* {length > 0 && (
            <div
              style={{
                padding: "5px 10px 5px 10px",
                backgroundColor: "#11cdef",
                borderRadius: "5px",
              }}
            >
              <span style={{ color: "#fff" }}>+{length}</span>
            </div>
          )} */}
        </Typography>
      </div>
    </components.ValueContainer>
  );
};

export const IndicatorSeparator = ({
  innerProps,
}: IndicatorSeparatorProps<ColourOption, true>) => {
  return <span className="IndicatorSeparatorSpan" {...innerProps} />;
};
// const menuHeaderStyle = {
//   color: "white",
//   width: "100%",
// };
export const MenuList = (props: MenuListProps) => {
  const [options] = useState(props.options ? [...props.options] : []);

  return (
    <components.MenuList {...props}>
      <div className="menuHeaderStyleMultiSelect">
        <div className="w-100 d-flex flex-column justify-content-start align-items-center">
          <div className="d-flex w-100 flex-row justify-content-between mb-1 pr-2">
            <div
              className="selectAllStyle"
              onClick={() => props.setValue(options, "select-option")}
            >
              <Typography variant="body3" color="primary">
                Select all
              </Typography>
            </div>
            <div className="selectAllStyle" onClick={() => props.clearValue()}>
              <Typography variant="body3" color="primary">
                Deselect all
              </Typography>
            </div>
          </div>
        </div>
      </div>
      {props.children}
      {/* <div className="d-flex flex-row justify-content-start ml-1 my-1">
        <Button size="sm" color="info">
          Apply
        </Button>
      </div> */}
    </components.MenuList>
  );
};
export const MultiValueRemove = (
  props: MultiValueRemoveProps<ColourOption>
) => {
  return <components.MultiValueRemove {...props}></components.MultiValueRemove>;
};
export const MultiValueLabel = ({
  children,
  ...props
}: MultiValueGenericProps<ColourOption>) => (
  <components.MultiValueLabel {...props}>{children}</components.MultiValueLabel>
);
export const CustomMultiSelect = (props: any) => {
  const customStyles = {
    control: (base: any, state: any) => ({
      ...base,
      borderColor: state.isFocused ? "#ddd" : props.isRequired ? "red" : "#ddd",
    }),
    valueContainer: (base: any) => ({
      ...base,
      width: "150px",
      maxWidth: "150px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "normal",
    }),
    multiValue: (base: any) => ({
      ...base,
      border: "none",
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      padding: 5,
      color: "black",
      display: "flex",
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      display: "none",
    }),
  };
  if (props.allowSelectAll) {
    return (
      <div>
        <ReactSelect
          {...props}
          styles={customStyles}
          components={{
            Option,
            MultiValue,
            IndicatorSeparator,
            MenuList,
            MultiValueLabel,
            ValueContainer,
            MultiValueRemove,
            MultiValueContainer,
          }}
          options={[...props.options]}
          isDisabled={props.disabled ? true : false}
          theme={(theme) => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
            },
          })}
          onChange={(selected: any) => {
            if (
              selected !== null &&
              selected.length > 0 &&
              selected[selected.length - 1].value === props.allOption.value
            ) {
              return props.onChange(props.options);
            }
            return props.onChange(selected);
          }}
        />
      </div>
    );
  }

  return (
    <ReactSelect
      {...props}
      theme={(theme) => ({
        ...theme,
        borderRadius: 8,
        colors: {
          ...theme.colors,
        },
      })}
    />
  );
};
